module.exports = __webpack_public_path__ + "components/country-flag/static/vn-a0cf7e7984a1dc08ee553395dae7adc1.svg";